import { render, staticRenderFns } from "./game-management.vue?vue&type=template&id=84ed14be&"
import script from "./game-management.vue?vue&type=script&lang=js&"
export * from "./game-management.vue?vue&type=script&lang=js&"
import style0 from "./game-management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports